import DTO from './DTO';

class NotificationDTO extends DTO {
  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'only_unread',
        type: Boolean,
        labelKey: 'notification.visible',
      },
      {
        name: 'created_at',
        type: String,
        validators: {},
        labelKey: 'created_at',
      },
      {
        name: 'type',
        type: String,
        validators: {},
        labelKey: 'type_notification',
      },
    ];
    super(attributes, params, isValidInit);
  }
}

export default NotificationDTO;
